export const selectError = (state) => state.app.error;

export const selectIsModalOpen = (state) => state.app.isModalOpen;

export const selectIsLoading = (state) => state.app.isLoading;

export const selectLoadingMessage = (state) => state.app.loadingMessage;